function UserChatMessage({ message }) {
  return (
    <div className="d-flex justify-content-end mb-2">
      <div
        className="bg-primary text-white rounded px-3 py-2"
        style={{ maxWidth: "70%" }}
      >
        <div className="text-break">{message.question}</div>
      </div>
    </div>
  );
}

export default UserChatMessage;